try{self['workbox:sw:7.4.1']&&_()}catch(e){}// eslint-disable-line